import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-help-box',
  templateUrl: './help-box.component.html',
  styleUrls: ['./help-box.component.scss']
})
export class HelpBoxComponent {
  supportEmail = 'support@calbd.com';
  supportPhone = '+880 1329 661 190';
  
  constructor(public translate: TranslateService) {}
}

